import _ from "lodash";
import alertRuleType from "./alertRule";
import controlLoopType from "./controlLoop";
import safetyLimitType from "./safetyLimit";

// Registro de tipos de automatización. La lista, el selector «Nueva automatización», las rutas
// (/automations/rules/<key>/<id>) y los borradores del asistente lo recorren. La clave de cada tipo es la misma del
// backend (AutomationItems::Types). Un tipo nuevo es una carpeta aquí con:
//   key, label, pickerTitle, pickerDescription, icon, order
//   Editor({ id, duplicateFromId, query, assistantDraft, groupOptions, onSaved, onCancel, setAssistantContext })
//   CardSummary({ item, compact }), CardDetails({ item }), subtitle(item), statusChip(item) → { label, color } | null
//   setEnabled(item, enabled), remove(item), confirmRemove(item), canDuplicate
//   draftTypes (draft_type del asistente que abre su editor), draftTarget(message) → id a editar | null
export const AUTOMATION_TYPES = _.sortBy([alertRuleType, controlLoopType, safetyLimitType], "order");

export const getAutomationType = (key) => _.find(AUTOMATION_TYPES, { key }) || null;

export const typeForDraft = (draftType) => _.find(AUTOMATION_TYPES, (type) => _.includes(type.draftTypes, draftType)) || null;
